export const ROUTES = {
  CART: "/cart",
  HOME: "/",
  SHOP: "/shop",
};

export const BASE_PAGE_TITLE = "DEPT® Apparel";
